import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmailVerificationComponent } from './pages/email-verification/email-verification.component';
import { HomeComponent } from './pages/home/home.component';
import { PostFeedComponent } from './pages/post-feed/post-feed.component';
import { FeedComponent } from './pages/feed/feed.component';
import { MessagesComponent } from './pages/messages/messages.component';
import { NotificationsComponent } from './pages/notifications/notifications.component';
import { AuthGuard } from './auth.guard';
import { MonProfilComponent } from './pages/mon-profil/mon-profil.component';
import { SearchComponent } from './pages/search/search.component';
import { VideoFeedComponent } from './pages/video-feed/video-feed.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { GuestGuard, GuestGuard2 } from './guards/guest.guard';
import { HomeComponent2Component } from './home-component2/home-component2.component';
import { UserProfileComponent } from './tools/user-profile/user-profile.component';
import { PostComponent } from './tools/post/post.component';
import { ProfileSetupComponent } from './pages/profile-setup/profile-setup.component';
import { AboutComponent } from './settings/about/about.component';
import { AccountDeletionComponent } from './pages/account-deletion/account-deletion.component';
import { NiagaIaComponent } from './pages/niaga-ia/niaga-ia.component';
import { FaqComponent } from './pages/faq/faq.component';

// Importations pour l'administration
import { AdminLoginComponent } from './admin/admin-login/admin-login.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { AccountDeletionRequestsComponent } from './admin/account-deletion-requests/account-deletion-requests.component';
import { AdminGuard } from './admin/guards/admin.guard';

// Note: Les routes d'administration sont définies dans le module AdminRoutingModule
// et sont automatiquement intégrées car ce module est importé dans AppModule.

const routes: Routes = [
  // Routes d'administration - on les place en premier pour leur donner priorité
  {
    path: 'admin',
    children: [
      { path: 'login', component: AdminLoginComponent },
      { 
        path: 'dashboard', 
        component: DashboardComponent, 
        canActivate: [AdminGuard] 
      },
      { 
        path: 'account-deletion-requests', 
        component: AccountDeletionRequestsComponent, 
        canActivate: [AdminGuard] 
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
    ]
  },
  
  // Routes principales de l'application
  { path: '', component: HomeComponent, canActivate: [GuestGuard] }, 
  { path: "emailVerification", component: EmailVerificationComponent },
  { path: 'home2', component: HomeComponent2Component },
  { path: 'about', component: AboutComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'delete-account', component: AccountDeletionComponent }, // Route pour la page de suppression de compte
  /**,
  { path: 'profileSetup', component: ProfileSetupComponent}, */
  
  { 
    path: 'phone-auth', 
    loadComponent: () => import('./pages/phone-auth/phone-auth.component').then(m => m.PhoneAuthComponent)
  },
  { path: "postfeed", component: PostFeedComponent, 
    canActivate: [AuthGuard],
    children: [
      { path: "feed", component: FeedComponent },
      { path: "messages", component: MessagesComponent },
      { path: "notifications", component: NotificationsComponent },
      { path: "profile", component: MonProfilComponent },
      { path: "search", component: SearchComponent },
      { path: "", component: FeedComponent },
      { path: 'videos', component: VideoFeedComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'niaga-ia', component: NiagaIaComponent },
      { path: 'userprofile/:uid', component: UserProfileComponent },
      { path: 'post/:postId', component: PostComponent }
    ]
  },
  
  // Route wildcard - toujours en dernier
  {path: "**", component: HomeComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
